import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UserModule } from './users/user.module';
import { LayoutModule } from './layout/layout.module';
import { AppComponent } from './app.component';
import { UserListComponent } from './users/user-list/user-list.component';
import { MenuComponent } from './layout/menu/menu.component';

import { AppRoutingModule } from './app.routing';
import { ConfigComponent } from './config/config';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    UserModule,
    LayoutModule,
    AppRoutingModule,
    FormsModule,
    HttpModule
  ],
  providers: [
    ConfigComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/app.module.ts